var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart101-template',{attrs:{"board-ids":[937],"data-type":_vm.dataType,"graph-id":102,"depth":_vm.depth,"date-field":"$.body.stdInfo.date","count-fields":['body.inspectChecked[*]'],"is-move-detail":false,"title":"작업계획서 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }